module.exports = __webpack_public_path__ + "img/25.c39a0766.png";